import { Fragment } from 'react';
import { Link } from 'react-router';

import type { LandingContent } from './landingContent';

const heroImagePriorityProps = { fetchPriority: 'high' as const };

interface LandingHeroSectionProps {
  hero: LandingContent['hero'];
  disclosure: LandingContent['demoDisclosure'];
  demoPath: string;
  onDemoClick: () => void;
}

export default function LandingHeroSection({
  hero,
  disclosure,
  demoPath,
  onDemoClick,
}: LandingHeroSectionProps) {
  const accessibleTitle = hero.title.join(' ');

  return (
    <section className="landing-hero" aria-labelledby="landing-hero-title">
      <div className="landing-hero-shell">
        <div className="landing-hero-copy">
          <p className="landing-hero-product">{hero.eyebrow}</p>
          <h1
            id="landing-hero-title"
            className="landing-hero-tagline"
            aria-label={accessibleTitle}
          >
            {hero.title.map((phrase, index) => (
              <Fragment key={phrase}>
                <span aria-hidden="true">{phrase}</span>
                {index < hero.title.length - 1 ? <br aria-hidden="true" /> : null}
              </Fragment>
            ))}
          </h1>
          <p className="landing-hero-desc">{hero.description}</p>
          <div className="landing-hero-actions">
            <Link
              className="landing-hero-cta"
              to={demoPath}
              reloadDocument
              aria-describedby="landing-demo-disclosure"
              onClick={onDemoClick}
            >
              {hero.primaryAction}
            </Link>
          </div>
          <p id="landing-demo-disclosure" className="landing-hero-availability">{disclosure}</p>
        </div>
        <figure className="landing-hero-media">
          <div className="landing-hero-stage">
            <img
              src="/img/studio-demo.webp"
              alt={hero.imageAlt}
              width={1600}
              height={1000}
              loading="eager"
              decoding="async"
              {...heroImagePriorityProps}
            />
          </div>
          <figcaption>{hero.imageCaption}</figcaption>
        </figure>
      </div>
    </section>
  );
}
